<template>
    <div class="text-center">
      <v-dialog dark v-model="dialog" width="500"> 

        <v-card>
        <v-card-title class="text-h5" style="background-color: #161d30;">
            <p class="text-center ma-0"> {{ item?'Editar Caja':'Apertura de Caja' }}  </p>
        </v-card-title>

        <v-card-text style="background-color: #283045;">
            <v-form ref="form" v-model="valid" lazy-validation>
              <p class="mb-0 mt-1 pt-8"> <b>Usuario actual:</b> {{ getuser }} </p>
              <p class="ma-0"> <b>Sede:</b> {{ getsede }} </p>
              <p class="ma-0"> <b>Fecha apertura:</b> {{ getfecha }} </p>
              <p class="text-center mt-8 mb-0"> <b>Recuerde que</b> el valor ingresado debe ser unico, la caja es unica por usuario y por sede, si ya tiene una caja aperturada no podra abrir otra hasta que cierre la anterior </p>
              <div class="row justify-center mt-4">
                    <div class="col-xs-12 col-sm-6">
                        <v-text-field v-model.number="valor" type="number" step="0.01" :prefix="moneta_str" :counter="10" :rules="valorRules" label="Monto de Apertura" required></v-text-field>
                    </div> 
                </div>

                <v-progress-linear v-if="loading" indeterminate color="green darken-2"></v-progress-linear>

                <p class="text-center red--text"> {{ msg }} </p>

                <div class="text-center">
                  <v-btn :disabled="loading" tile color="success" class="mr-4" @click="registrar()" >
                    <v-icon left>mdi-package-variant</v-icon>
                    {{ item?'guardar cambios':'Abrir caja' }}
                  </v-btn>
                </div> 
            </v-form>
        </v-card-text> 
      </v-card>
  
        
      </v-dialog>
    </div>
  </template>

<script>
import xaxios from '@/xaxios';

export default {
  data () {
    return {
      dialog: false,
      valid: true,
      loading: false,
      valor: '',
      msg: '',
      valorRules: [
        v => (!!v || v >= 0) || 'requerido',
        v => (v >= 0 || v === 0) || 'positivo',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
      item: null, 
      moneta_str: ''
    }
  },

  computed:{
    getuser(){
      let n = this.$store.state.DATA_USER.nombres;
      let ap = this.$store.state.DATA_USER.pri_apellido;
      let am = this.$store.state.DATA_USER.seg_apellido;
      if(!am) am = '';
      return `${n} ${ap} ${am}`;
    },
    getfecha(){
      const fechaActual = new Date(); 
      const dia = fechaActual.getDate();
      const mes = fechaActual.getMonth() + 1;
      const año = fechaActual.getFullYear(); 
      const fechaFormateada = `${dia.toString().padStart(2, '0')}/${mes.toString().padStart(2, '0')}/${año}`;
      return fechaFormateada;
    },
    getsede(){
      if(!this.$store.state.CARGO) return '';
      let n = this.$store.state.CARGO.sede.nombre;
      return n;
    }
  },

  methods: {
    openmodal(item=null){ 
        this.dialog = true; 
        this.valor = '';
        this.item = item;
        if(item) this.valor = item.monto_apertura;

        this.moneta_str = 'Bs.'
        const unidad = this.$store.state.CARGO.sede.unidad_negocio
        if(unidad==14 || unidad==15) this.moneta_str = '$'
    },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },

      async registrar(){
        this.msg = '';
        if(!this.$refs.form.validate()) return;
        this.loading = true;

        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas`; 
        const sedeid = this.$store.state.CARGO.sede.id;
        const userid = this.$store.state.DATA_USER.id;
        const data = {
          sede_id: sedeid,
          user_id: userid,
          monto_apertura: this.valor,
        }
        if (this.item){
            data.id = this.item.id;
            const res = await xaxios.put(url,data).then(x=>x).catch(x=>x);
            window.console.log('res:', res);
            if(res && res.data && res.data.data.id) {
                this.dialog = false;
                this.$emit('success')
            }
            else this.msgErr(res);
            
        }else{
            const res = await xaxios.post(url,data).then(x=>x).catch(x=>x);
            window.console.log('res:', res);
            if(res && res.data && res.data.data.id) {
                this.dialog = false;
                this.$emit('success');
                this.$root.$notify.show(`caja aperturada`, {color:'#03931D',x: 'right',y:'top'});
                this.$store.state.cajaperturada = true;
            }
            else this.msgErr(res);
            
        }
        
        this.loading = false;
      },

      msgErr(res){ 
        try{ this.msg = res.response.data.data; }
        catch(e){ this.msg = res }
        
      }
    },
}
</script>